import withChicken from './../../../image/wok/chicken.webp';
import withBeef from './../../../image/wok/beef.webp';
import withSalmon from './../../../image/wok/salmon.webp';
import withSeaFood from './../../../image/wok/seafood.webp';
import withVegetables from './../../../image/wok/vegetables.webp';
import withPig from './../../../image/wok/pig.webp';



export const imageWok = {
    withChicken: withChicken,
    withBeef:withBeef,
    withSalmon:withSalmon,
    withSeaFood:withSeaFood,
    withVegetables:withVegetables,
    withPig:withPig
}
